export default function PatientDischargedIcon({ width = 12, height = 12, ...props }: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={width} height={height} viewBox='0 0 12 12' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        d='M6.75 6.25H11.75'
        stroke='currentColor'
        strokeWidth='0.85'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M9.75 4.25L11.75 6.25L9.75 8.25'
        stroke='currentColor'
        strokeWidth='0.85'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M8.25 7.75V10.75H5.25'
        stroke='currentColor'
        strokeWidth='0.85'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M5.25 1.75H8.25V4.75'
        stroke='currentColor'
        strokeWidth='0.85'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M5.25 11.75L0.25 10.75V1.75L5.25 0.75V11.75Z'
        stroke='currentColor'
        strokeWidth='0.85'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}
